import Link from 'next/link';
import { StudioshotLogo } from '../icons/StudioshotLogo';
export const StudioShotLogoLink = ({
  doNotLink = false
}: {
  doNotLink?: boolean;
}) => doNotLink ? <div className="flex items-center justify-center">
      <StudioshotLogo className="h-6 w-auto text-primary" />
    </div> : <Link href="/overview">
      <div className="flex items-center justify-center">
        <StudioshotLogo className="h-6 w-auto text-primary" />
      </div>
    </Link>;